<div class="wrapper has-padding">

    <h1 class="bofa--heading is-1">
      <div>
        Unauthorized Access !
    </div>
  </h1>
    <p>You are not authorized to access the application. </p>
    <p>Please return to your application by selecting the link in the email. If you have trouble accessing your application, please reach out to the contact listed in your invitation email. </p>
  </div>
